// extracted by mini-css-extract-plugin
export default {"TelegramWeb":"TeleframWeb_TelegramWeb__4Kj9x"};